import { render, staticRenderFns } from "./ProductCategorySidebar.vue?vue&type=template&id=7b2e8cc8&scoped=true&"
import script from "./ProductCategorySidebar.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategorySidebar.vue?vue&type=style&index=0&id=7b2e8cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2e8cc8",
  null
  
)

export default component.exports